import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';

var partition = function partition(reducable, predicate) {
  var result = reducable.reduce(function (acc, currentValue) {
    return predicate(currentValue) ? _objectSpread2(_objectSpread2({}, acc), {}, {
      truish: [].concat(_toConsumableArray(acc.truish), [currentValue])
    }) : _objectSpread2(_objectSpread2({}, acc), {}, {
      falsish: [].concat(_toConsumableArray(acc.falsish), [currentValue])
    });
  }, {
    truish: [],
    falsish: []
  });
  return [result.truish, result.falsish];
};

export { partition };
